import { render, staticRenderFns } from "./Ort.vue?vue&type=template&id=4bc72458&scoped=true&"
import script from "./Ort.vue?vue&type=script&lang=js&"
export * from "./Ort.vue?vue&type=script&lang=js&"
import style0 from "./Ort.vue?vue&type=style&index=0&id=4bc72458&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc72458",
  null
  
)

export default component.exports